<template>
    <div class="add-rubric-and-students">
        <design-2021-rubric-survey-choose-skills-component
            v-model="surveyStudentsSkills.rubrics"
            :skill-trees-in="skillTreesIn"
            @input="update">
        </design-2021-rubric-survey-choose-skills-component>

        <design-2021-rubric-survey-choose-students-component
            v-model="surveyStudentsSkills"
            :las-main-groups-in="lasMainGroupsIn"
            :las-groups-in="lasGroupsIn"
            :is-project="isProject"
            :project-options-in="projectOptionsIn">
        </design-2021-rubric-survey-choose-students-component>

        <design-2021-rubric-survey-rubrics-overview-component
            v-model="surveyStudentsSkills.rubrics"
            @remove-skillTree-groups="removeGroups">
        </design-2021-rubric-survey-rubrics-overview-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-add-skills-and-students-component',
    props: {
        skillTreesIn: {
            type: Array,
            required: true,
        },

        isProject: {
            type: Boolean,
            required: true,
        },

        projectOptionsIn: {
            type: Array,
            required: true,
        },
        lasMainGroupsIn: {
            type: Array,
            required: true,
        },
        lasGroupsIn: {
            type: Array,
            required: true,
        },

        value: {
            type: [Array, Object],
        },
    },

    data() {
        return {
            groups: {
                all_las_groups: this.lasGroupsIn ? this.lasGroupsIn : [],
                all_las_main_groups: this.lasMainGroupsIn ? this.lasMainGroupsIn : [],
            },
            surveyStudentsSkills: {
                rubrics: this.value.rubrics ? this.value.rubrics : [],
                lasMainGroups: this.value.lasMainGroups ? this.value.lasMainGroups : [],
                lasGroups: this.value.lasGroups ? this.value.lasGroups : [],
                projects: this.value.projects ? this.value.projects : [],
            },
        };
    },

    methods: {
        removeGroups(skillTreeId) {
            const skillTree = this.skillTreesIn.find((skillTree) => skillTree.id === skillTreeId);
            const lasGroups = skillTree.las_groups.map((group) => group.id);
            const lasMainGroups = skillTree.las_main_groups.map((group) => group.id);

            this.surveyStudentsSkills.lasGroups = this.surveyStudentsSkills.lasGroups.filter(
                (group) => lasGroups.indexOf(group.id) === -1,
            );
            this.surveyStudentsSkills.lasMainGroups = this.surveyStudentsSkills.lasMainGroups.filter(
                (main_group) => lasMainGroups.indexOf(main_group.id) === -1,
            );
        },

        update() {
            this.$emit('input', this.surveyStudentsSkills);
        },
    },

    computed: {},

    watch: {
        surveyStudentsSkills: function () {
            this.$emit('input', this.surveyStudentsSkills);
        },
    },
};
</script>

<style scoped lang="scss">
.add-rubric-and-students {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    column-gap: $grid-gutter-width;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');
}

.survey-choose-rubric,
.survey-choose-student {
    flex: 1 1 100%;
}

.survey-overview {
    flex: 1 0 100%;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .add-rubric-and-students {
        row-gap: 0;
    }

    .survey-choose-rubric,
    .survey-choose-student {
        flex: 0 1 calc(50% - 15px);
    }
}
</style>
